import React from "react";
import { TextField, Autocomplete, Popper } from "@mui/material";
import { useTranslation } from "react-i18next";

const AutocompleteComponent = React.forwardRef(({
  label,
  name,
  options,
  required,
  onChange = () => { },
  defaultValue = null,
  disableClearable = false,
  error,
  ...field
},
  ref
) => {
  const { t } = useTranslation()
  return (
    <Autocomplete
      noOptionsText={t('No Options')}
      ref={ref}
      disablePortal
      disableClearable={disableClearable}
      options={options}
      onChange={(e, data) => onChange(data)}
      name={name}
      defaultValue={defaultValue}
      value={field.value ? field.value : null}
      renderInput={(params) => (
        <TextField
          {...params}
          required={required}
          label={label}
          margin="normal"
          error={error}
        />
      )}
      PopperComponent={({ style, ...props }) => (
        <Popper
          {...props}
          style={{ ...style, zIndex: 20 }}
        />
      )}
    />
  )
})

export default AutocompleteComponent;

AutocompleteComponent.defaultProps = {
  label: "",
  options: [],
};
